// Static studio-reported capacities (Phase 9 — non-editable)
export const STUDIO_CAPACITY = {
  dryingShelves: 120,    // pieces that can dry at once
  kilnVolumeLitres: 90,  // kiln size (litres)
  kilnLoadFactor: 0.75,  // safety buffer
  bisqueDailyLimit: 40,  // pieces to bisque per day
  glazeDailyLimit: 40,   // pieces to glaze per day
};
